var _a, _b, _c, _d, _e, _f;
/**More actions
 * Defines user roles in the system
 */
export var UserRole;
(function (UserRole) {
    UserRole["SuperAdmin"] = "SuperAdmin";
    UserRole["FinancialOfficer"] = "FinancialOfficer";
    UserRole["FunctionalDepartment"] = "FunctionalDepartment";
    UserRole["SCFO"] = "SCFO"; // Smart Chief Financial Officer with extended access
})(UserRole || (UserRole = {}));
/**
 * Defines subjects (modules) in the system
 * Each subject corresponds to a specific feature or module
 */
export var SUBJECTS;
(function (SUBJECTS) {
    SUBJECTS["PUBLIC"] = "public";
    SUBJECTS["IMAGES"] = "images";
    // Private access
    SUBJECTS["OVERVIEW"] = "cf-overview";
    SUBJECTS["STATEMENT"] = "cf-statement";
    SUBJECTS["TEMPLATE"] = "cf-template";
    SUBJECTS["USER_MANAGEMENT"] = "account-management";
    SUBJECTS["DEPT_MANAGEMENT"] = "dept-management";
    SUBJECTS["MULTI_LANGUAGE"] = "multi-languages";
    SUBJECTS["AGGREGRATE_CF"] = "aggregrate-cf";
    SUBJECTS["SUPPLIER_MANAGEMENT"] = "supplier-management";
    SUBJECTS["SUPPLIER_BALANCE"] = "supplier-balance";
    SUBJECTS["AP_OVERVIEW"] = "ap-overview";
    SUBJECTS["AR_OVERVIEW"] = "ar-overview";
    SUBJECTS["CUSTOMER_MANAGEMENT"] = "customer-management";
    SUBJECTS["CUSTOMER_BALANCE"] = "customer-balance";
    SUBJECTS["PAYMENT"] = "payment";
    SUBJECTS["DUNNING_LETTER"] = "dunning-letter";
    // Add Subject Here
})(SUBJECTS || (SUBJECTS = {}));
/**
 * Defines possible actions that can be performed on subjects
 */
export var Actions;
(function (Actions) {
    Actions["VIEW"] = "VIEW";
    Actions["EDIT"] = "EDIT";
    Actions["CREATE"] = "CREATE";
    Actions["DELETE"] = "DELETE";
    Actions["MANAGE"] = "MANAGE"; // Manage (view list)
})(Actions || (Actions = {}));
/**
 * Defines detailed permissions for each user role
 * Each role has specific access rights to subjects and their corresponding actions
 */
export var rolePermissions = (_a = {},
    _a[UserRole.SuperAdmin] = (_b = {},
        _b[SUBJECTS.USER_MANAGEMENT] = [Actions.VIEW, Actions.EDIT, Actions.CREATE, Actions.MANAGE],
        _b[SUBJECTS.DEPT_MANAGEMENT] = [Actions.VIEW, Actions.EDIT, Actions.CREATE, Actions.MANAGE],
        _b[SUBJECTS.MULTI_LANGUAGE] = [Actions.VIEW, Actions.EDIT, Actions.CREATE, Actions.MANAGE] // Full access to language management
    ,
        _b),
    _a[UserRole.FinancialOfficer] = (_c = {},
        _c[SUBJECTS.OVERVIEW] = [Actions.MANAGE], // View-only access to overview
        _c[SUBJECTS.STATEMENT] = [Actions.VIEW, Actions.CREATE, Actions.DELETE, Actions.MANAGE], // Manage financial statements
        _c[SUBJECTS.TEMPLATE] = [Actions.VIEW, Actions.CREATE, Actions.EDIT, Actions.DELETE, Actions.MANAGE], // Full access to templates
        _c[SUBJECTS.AGGREGRATE_CF] = [Actions.MANAGE],
        _c[SUBJECTS.SUPPLIER_MANAGEMENT] = [Actions.MANAGE, Actions.CREATE, Actions.VIEW],
        _c[SUBJECTS.SUPPLIER_BALANCE] = [Actions.MANAGE, Actions.CREATE, Actions.VIEW],
        _c[SUBJECTS.AP_OVERVIEW] = [Actions.MANAGE],
        _c[SUBJECTS.AR_OVERVIEW] = [Actions.MANAGE],
        _c[SUBJECTS.CUSTOMER_MANAGEMENT] = [Actions.MANAGE, Actions.CREATE, Actions.VIEW],
        _c[SUBJECTS.CUSTOMER_BALANCE] = [Actions.MANAGE, Actions.CREATE, Actions.VIEW],
        _c[SUBJECTS.PAYMENT] = [Actions.MANAGE, Actions.CREATE, Actions.VIEW],
        _c[SUBJECTS.DUNNING_LETTER] = [Actions.MANAGE, Actions.CREATE, Actions.VIEW],
        _c),
    _a[UserRole.FunctionalDepartment] = (_d = {},
        _d[SUBJECTS.STATEMENT] = [Actions.VIEW, Actions.EDIT, Actions.MANAGE] // Limited access to statements
    ,
        _d),
    _a[UserRole.SCFO] = (_e = {},
        _e[SUBJECTS.OVERVIEW] = [Actions.MANAGE],
        _e[SUBJECTS.AGGREGRATE_CF] = [Actions.VIEW, Actions.MANAGE],
        _e[SUBJECTS.STATEMENT] = [Actions.VIEW, Actions.MANAGE],
        _e[SUBJECTS.SUPPLIER_MANAGEMENT] = [Actions.MANAGE, Actions.CREATE, Actions.VIEW],
        _e[SUBJECTS.SUPPLIER_BALANCE] = [Actions.MANAGE, Actions.CREATE, Actions.VIEW],
        _e[SUBJECTS.AP_OVERVIEW] = [Actions.MANAGE],
        _e[SUBJECTS.AR_OVERVIEW] = [Actions.MANAGE],
        _e[SUBJECTS.CUSTOMER_MANAGEMENT] = [Actions.MANAGE, Actions.CREATE, Actions.VIEW],
        _e[SUBJECTS.CUSTOMER_BALANCE] = [Actions.MANAGE, Actions.CREATE, Actions.VIEW],
        _e[SUBJECTS.PAYMENT] = [Actions.MANAGE, Actions.CREATE, Actions.VIEW],
        _e[SUBJECTS.DUNNING_LETTER] = [Actions.MANAGE, Actions.CREATE, Actions.VIEW],
        _e),
    _a);
/**
 * Default permissions for all roles
 * Can be used when a role has no access to any subject
 */
export var defaultPermissions = (_f = {},
    _f[SUBJECTS.PUBLIC] = [Actions.VIEW, Actions.MANAGE],
    _f[SUBJECTS.IMAGES] = [Actions.VIEW, Actions.MANAGE],
    _f);
